module.exports = __webpack_public_path__ + "img/ic_search_bl.ec2313b6.svg";